import httpClient from './httpClient'

const END_POINT = '/lookup/vehiclegroups?excludeEmpty=true'

const getAllGroups = () => httpClient.get(END_POINT)

export { getAllGroups }
